%YAML 1.1
%TAG !u! tag:unity3d.com,2011:
--- !u!114 &11400000
MonoBehaviour:
  m_ObjectHideFlags: 0
  m_CorrespondingSourceObject: {fileID: 0}
  m_PrefabInstance: {fileID: 0}
  m_PrefabAsset: {fileID: 0}
  m_GameObject: {fileID: 0}
  m_Enabled: 1
  m_EditorHideFlags: 0
  m_Script: {fileID: 11500000, guid: 85449c2ea301fc54091646f096d9e4dc, type: 3}
  m_Name: LightningStorm
  m_EditorClassIdentifier: 
  impactPrefab: {fileID: 0}
  handGlowPrefab: {fileID: 0}
  handGlowScale: 0.2
  castAuraPrefab: {fileID: 727422648304881801, guid: a9f11eefd58c0244ba94098589ebf7db,
    type: 3}
  castAuraScale: 0.4
  castAuraYOffset: 0.5
  attachCastAuraToCaster: 0
  playOnCast: []
  castSound: {fileID: 0}
  castSoundVolume: 0.2
  soundBeforeChannel: {fileID: 8300000, guid: 044eae113b60d7e46b52f96eb863fa08, type: 3}
  beforeChannelSoundDelay: 0
  soundAfterChannel: {fileID: 0}
  afterChannelSoundDelay: 0
  animation: 0
  animationVariation: 22
  castDelay: 850
  animationSpeed: 2
  animationDuration: 1
  skipCooldownOnChannel: 0
  spellName: Lightning Storm
  description: Deal <b>19</b> damage instantly and every <b>1.5</b> seconds to all
    enemies within <b>12</b> yards of yourself for <b>8</b> seconds. The storm becomes
    dormant if you are <b>Stunned</b>, <b>Silenced</b>, or <b>Incapacitated</b>.
  icon: {fileID: 2800000, guid: 7f26fddce2a24b04aafe84682aabe7d5, type: 3}
  usableBy: 0e000000
  cooldown: 85
  castTime: 0
  isCastInterruptible: 1
  channelTime: 0
  isOnGlobalCooldown: 1
  aoeRadius: 0
  isHidden: 0
  isInternal: 0
  isRegional: 0
  preventManualCasts: 0
  useKeyboardForFacing: 0
  spellType: {fileID: 11400000, guid: 80cddad32b4f07e4bbf640afdccb32f4, type: 2}
  spellKey: 100065
  alwaysCastableSpell: 0
  luaScript: {fileID: 4900000, guid: cc5b8c8e0220046459fe82b4e33b751e, type: 3}
